// src/ui/BootGreetings.jsx — the browser's cold start.
//
// 🟥 THE FIELD OF DRIFTING "HELLO" CHIPS WENT, on both clients at once. It was
//    a second launch screen — a designed thing between the icon and the chats,
//    shown on every open because every open waited for the server. The phone
//    now continues its native launch image (the wordmark, nothing else) and
//    lets a remembered device straight in; this is the same moment here.
//
// 🟢 ONE MARK, CENTRED, ON THE PAGE BACKGROUND. The brand mark the header and
//    the login gate already use, drawing itself on once (its 'mount' play —
//    the greeting it is everywhere else), and the weak-network hint beneath
//    it only once the gate has dragged on. Nothing to translate, nothing to
//    animate in, nothing to look at twice.
//
//    The file keeps its name so the one import in App.jsx is untouched.
import React, { useEffect, useState } from 'react';
import BrandLottie from './BrandLottie';

/** the weak-network hint waits this long — the same wait as the phone */
export const HINT_AFTER_MS = 4500;

export default function BootGreetings({ hint = 'Connecting…' }) {
  const [showHint, setShowHint] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShowHint(true), HINT_AFTER_MS);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="boot-field boot-minimal" role="status" aria-label={hint}>
      <BrandLottie size={96} bare label="Allo" />
      <div className={`boot-hint ${showHint ? 'on' : ''}`} aria-hidden={!showHint}><span>{hint}</span></div>
    </div>
  );
}
